import { HistoryEntry } from '../../types/calculator';

const STORAGE_KEY = 'vial_metrics';

export const saveToHistory = (entry: HistoryEntry): void => {
  const history = getHistory();
  history.unshift(entry);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
};

export const getHistory = (): HistoryEntry[] => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
};

export const clearHistory = (): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
};

export const deleteHistoryEntry = (id: string): void => {
  const history = getHistory();
  const filtered = history.filter(entry => entry.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
};